<mcg-window #listCerraduras
  [loading]="loading()"
  [title]="windowTitle()"
  [actions]="actions"
  (actionButtonClicked)="actionButtonClicked($event)"
  (windowClosed)="onClose()"
>
  <app-header #header
    [exportar]="true"
    [buscador]="true"
    [filtro]="true"
    [resetFiltro]="true"
    (eventExportar)="onExportar()"
    (eventBuscador)="onBuscar()"
    (eventFilter)="eventFilter()"
    (eventResetFilter)="eventResetFilter()">
  </app-header>
  <jqxGrid #gridCerraduras [theme]="theme" [width]="'100%'" [height]="'calc(100% - 50px)'" [source]="dataAdapter" [columnsresize]="true"
    [localization]="langGrid" [filterable]="true" [columns]="columns" [showrowlines]="false" [appCellClick]
    [enablebrowserselection]="true" [showcolumnlines]="true" [pageable]="false" [sortable]="true" [altrows]="true"
    [rowsheight]="25" [columnsheight]="25" [editable]="false" [groupable]="true" [selectionmode]="'checkbox'" [filter]="filter"
    [showemptyrow]="false" [updatefilterconditions]="updatefilterconditions" (onRowselect)="onSelect()"
    [columnmenuopening]="columnmenuopening" (onCellclick)="onCellClick($event.args)" (onRowunselect)="onUnSelect($event.args)"
    (onFilter)="onGridDataUpdated()" (onBindingcomplete)="onGridDataUpdated()" (onRowdoubleclick)="onRowdoubleclick($event.args.row.id)">
  </jqxGrid>
</mcg-window>

<div *ngIf="detalleCerradura" #informacionCerradura>
  <app-detalle-cerradura [cerradura]="cerradura" (closeForm)="closeDetailCerradura()">
  </app-detalle-cerradura>
</div>

<div #formLockConfiguracion>
</div>
